import { render, staticRenderFns } from "./PaymentPortal.vue?vue&type=template&id=22b3216c&"
import script from "./PaymentPortal.vue?vue&type=script&lang=js&"
export * from "./PaymentPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports